import { GetTransactionParams } from '../../models/payload/transaction';
import { ropoloRequest } from '../axios';

const getAllMyTransactions = async (params: GetTransactionParams) =>
  (await ropoloRequest.transactionsMeList(params))?.data;

export default getAllMyTransactions;
